import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('ShopPackTranslation')
export class ShopPackTranslation {

  @JsonProperty('language_id', Number)
  languageId: number = 0;

  @JsonProperty('title', String)
  title: string = '';

  @JsonProperty('description', String)
  description: string = '';
}
